<template>
  <div>
    <div ref="printContent" style="padding: 0 30px; font-size: 14px">
      <div class="close">
        <span @click="goBack">X</span>
      </div>
      <h4 style="text-align: center; margin-bottom: 20px; font-size: 20px">
        《{{ title }}》
      </h4>
      <div style="text-align: center; font-size: 20px">
        网络助学课程资源教学内容与自学考试课程考试大纲知识点对照表
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#d7d7d7' }"
      >
        <el-table-column
          prop="courseName"
          label="课程教学内容知识点"
          min-width="300"
        >
        </el-table-column>
        <el-table-column prop="courseSection" label="所在教学章节">
        </el-table-column>
        <el-table-column
          prop="examName"
          label="自学考试课程考试大纲知识点"
          min-width="300"
        >
        </el-table-column>
        <el-table-column prop="examSection" label="所在大纲章节">
        </el-table-column>
        <el-table-column prop="status" label="状态"> </el-table-column>
        <el-table-column prop="remark" label="备注"> </el-table-column>
      </el-table>
      <div class="explain">
        <h5 class="title">对照表说明：</h5>
        <div class="desc">
          1.覆盖：课程资源教学知识点包含有自考考试大纲知识点相应内容
        </div>
        <div class="desc">2.新增：教学内容超出自考考试大纲知识点要求的内容</div>
      </div>
      <div class="info">
        <span class="curr_material">现用教材：</span>
        <span class="main_material">主要参考资料：</span>
      </div>
      <div class="assessment_experts">评审专家：</div>
      <div class="footer">
        <span class="moderator">评审组长：</span>
        <span class="date">日期：</span>
      </div>
    </div>
    <div class="btn" v-if="userType !== '53'">
      <el-button type="primary" @click="print">打印对照表</el-button>
    </div>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/checkCourseware'
import * as api2 from '@/api/courseStructure/courseStructure'
import html2canvas from 'html2canvas'
import printJS from 'print-js'
export default {
  name: 'KnowledgeInser',
  components: {},
  inject: ['reload'],
  props: ['title', 'userType'],
  data() {
    return {
      courseId: this.$route.query.id,
      courseWareId: '',
      dialogVisible: false,
      institutionId: '',
      tableData: [],
    }
  },
  methods: {
    goBack() {
      this.$emit('returnCourseTree')
    },
    getSchoolByUid() {
      api.getSchoolByUid(this.getUId).then(({ data }) => {
        if (data.code == 100000) {
          data = data.data
          this.institutionId = data.id
        }
      })
    },
    getCourseWareId() {
      api2.getCourseId({ courseId: this.courseId }).then(({ data }) => {
        this.courseWareId = data
        this.getKnowledgeComparisonTable()
      })
    },
    getKnowledgeComparisonTable() {
      api
        .getKnowledgeComparisonTable({
          courseWareId: this.courseWareId,
          courseId: this.courseId,
        })
        .then(({ data }) => {
          if (data.code === 100000) {
            data.data.forEach((item) => {
              if (item.courseName !== null && item.examName !== null) {
                item.status = '覆盖'
              } else if (item.courseName !== null && item.examName === null) {
                item.status = '新增'
              } else {
                item.status = ''
              }
            })
            this.tableData = data.data
          }
        })
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
    },
    print() {
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      // 转图片打印
      html2canvas(this.$refs.printContent, {
        scale: 2,
      }).then((canvas) => {
        const url = canvas.toDataURL()
        this.img = url
        printJS({
          printable: url,
          type: 'image',
          documentTitle: '',
        })
      })
    },
  },
  created() {
    this.getCourseWareId()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') || '4'
    },
  },
}
</script>

<style lang="scss" scoped>
.close {
  margin-bottom: 10px;
  text-align: right;
  span {
    font-size: 20px;
    cursor: pointer;
  }
}
.explain {
  .title {
    margin: 20px 0;
  }
  .desc {
    margin-bottom: 10px;
  }
}
.info {
  margin-bottom: 10px;
  .curr_material {
    margin-right: 700px;
  }
}
.assessment_experts {
  margin-bottom: 10px;
}
.footer {
  margin-bottom: 10px;
  .moderator {
    margin-left: 796px;
    margin-right: 300px;
  }
}
.btn {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}
</style>
